import PricingPocNotes from "@entities/PricingProject/ui/PricingPocNotes";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import styles from "./styles.module.scss";

type ClosureCreatorNotesCellProps = {
  record: IBriefInfluencerV2;
  isEditing: boolean;
  onStartEdit: () => void;
  onClose: () => void;
  onSuccess: () => void;
};

export function ClosureCreatorNotesCell({
  record,
  isEditing,
  onStartEdit,
  onClose,
  onSuccess,
}: ClosureCreatorNotesCellProps) {
  if (isEditing) {
    return (
      <PricingPocNotes
        notes={record.pricingNotes || ""}
        briefInfluencerId={record._id}
        handleSuccess={onSuccess}
        handleGoBack={onClose}
        showGoBackButton={Boolean(record.pricingNotes)}
      />
    );
  }

  return (
    <button
      type="button"
      className={styles.notesTrigger}
      onClick={(event) => {
        event.stopPropagation();
        onStartEdit();
      }}
    >
      {record.pricingNotes ? (
        <pre className={styles.pricingNotes}>{record.pricingNotes}</pre>
      ) : (
        <span className={styles.emptyPlaceholder}>-</span>
      )}
    </button>
  );
}
